import { createStore, combineReducers } from 'redux';

import main from './mainStore/reducers';
import branches_data from './branches/reducers';
import sellers_data from './sellers/reducers';
import searchReferrals_data from './searchReferrals/reducers';
import referralItems_data from './referralItems/reducers';
import categories_data from './categories/reducers';
import distressedCategories_data from './distressedCategories/reducers';
import closures_data from './closures/reducers';
import cashRegisters_data from './cashRegisters/reducers';
import countries_data from './countries/reducers';
import stockControls_data from './stockControls/reducers';
import vouchers_data from './vouchers/reducers';
import branch_data from './branches/reducers';
import concept_data from './concepts/reducers';

export default createStore(combineReducers({
    main,
    branches_data,
    sellers_data,
    searchReferrals_data,
    referralItems_data,
    categories_data,
    distressedCategories_data,
    closures_data,
    cashRegisters_data,
    countries_data,
    stockControls_data,
    vouchers_data,
    branch_data,
    concept_data
}), window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());